module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function (fox) {
	"use strict";
	fox.registerWidget('UserOfferBase', {
		const: {// don't forget about object Offer when change states
			STATE_NEW: 1,
			STATE_CONFIRMED: 2,
			STATE_ACTIVE: 3,
			STATE_DECLINED: 4,
			STATE_EXPIRED: 5,
			STATE_SUSPENDED: 6
		},
		_offer: {}, /* DataObject Offer_Site */
		_actions: [],
		_controller: false,

		prepare: function (controller, offer) {
			this._controller = controller;
			this.setOffer(offer);

			this.handleActions();
			this.run();
		},

		handleActions: function () {
			var offerSettings = this._offer.get('settings()');
			if (fox.isSet(offerSettings.actions)) {
				fox.each(offerSettings.actions, function (action) {
					this.addHandler(action);
				}, this);
			}

			this.addHandler('offersPrepared');
		},

		addHandler: function (action) {
			this._actions.push(action);
			this.handleEvent('@parent', action, 'callAction', {
				listenHistory: true
			});
		},

		callAction: function (options, w, e) {
			var method = 'action' + fox.ucfirst(e);
			if (typeof this[method] === 'function') {
				this[method](options);
			} else {
				throw 'Handled action: ' + method + ' does not exists in offer: ' + this.alias;
			}
		},

		getActions: function () {
			return this._actions;
		},

		setOffer: function(offer) {
			this._offer = offer;
		},

		getUserOffer: function () {
			return this._offer.getRelatedObject('userOffer');
		},

		_createUserOffer: function () {
			var userOfferDl = this._offer.relation('userOffer');
			userOfferDl.addObject({
				state: this.const.STATE_NEW,
				userId: fox.site.member.getObjectValue('id'),
				offerSiteId: this._offer.get('id')
			});

			return userOfferDl.getObject();
		},

		reload: function (callback) {
			this._controller.reloadOffer(this.alias, fox.bind(function (data, w, e) {
				if (e === 'ready') {
					var userOffer = this.getUserOffer();
					fox.each(data, function (v, k) {
						userOffer.set(k, v);
					}, this);
				}

				callback(data, w, e);
			}, this));
		},

		update: function (action, values, withoutSave) {// create different methods to update state if needed, i.e declineOffer, approveOffer etc.
			if (!values) {
				values = {};
			}

			var userOffer = this.getUserOffer();

			if (!userOffer) {
				userOffer = this._createUserOffer();
			}

			if (!fox.isEmpty(values)) {
				fox.each(values, function (v, k) {
					userOffer.set(k, v);
				}, this);
			}

			this._controller.updateOffer(action, this.alias, values, withoutSave);
		},

		updateState: function (state, withoutSave) {
			switch (state) {
				case 'new':
					this.update('new', {}, withoutSave);
				break;
				case 'confirmed':
					this.update('state', {state: this.const.STATE_CONFIRMED}, withoutSave);
				break;
				case 'active':
					this.update('state', {state: this.const.STATE_ACTIVE}, withoutSave);
				break;
				case 'suspended':
					this.update('state', {state: this.const.STATE_SUSPENDED}, withoutSave);
				break;
			}
		},

		updateContext: function (values) {
			this.update('context', {
				context: values
			});
		},

		sendAction: function (action, params, callback) {
			this._controller.sendOfferAction(action, this.alias, params, callback);
		},

		getAction: function (action) {
			return this._controller.getOfferAction(action, this.alias);
		},

		actionOffersPrepared: function () {
			//abstract
		},

		log: function (text, tags) {
			var userOffer = this.getUserOffer();
			tags = fox.merge({
				siteId: this._offer.get('siteId') || fox.site.dl.getObjectValue('id'),
				userId: userOffer.get('userId') || fox.site.member.getObjectValue('id'),
				offerId: this._offer.get('offerId.id'),
				offerSiteId: this._offer.get('id')
			}, tags);

			if (userOffer.get('id')) {
				tags.offerUserId = userOffer.get('id');
			}

			this._controller.log(text, tags);
		}

	}, 'Controller');
})(fox);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/main/widget/offer/controllers/UserOfferBase.js
// module id = 128
// module chunks = 4